import React from 'react';
import { useController } from 'react-hook-form';
import { Form, Select } from '@weezevent/nacre';
import { FieldErrorMessage } from '../FieldErrorMessage';
import PropTypes from 'prop-types';
import useSearchableSelectProps from './useSearchableSelectProps';

export const FormSelect = ({ name, label, disabled = false, required = false, onSearch, options, isClearable, isSearchable, ...rest }) => {
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({
        name
    });

    const onClear = () => {
        if (isClearable) {
            onChange(null);
        }

        resetSearch();
    };

    const { selectProps, resetSearch } = useSearchableSelectProps(options, onSearch);
    const currentSelectProps = isSearchable ? selectProps : {};

    return (
        <Form.Field>
            <Form.Label for={name} label={label} required={required} />
            <Select
                errors={!!error}
                id={name}
                value={value}
                onChange={(_, { value }) => {
                    onChange(value);
                }}
                disabled={disabled}
                onClear={disabled ? undefined : onClear}
                options={options}
                {...currentSelectProps}
                {...rest}
            />
            <FieldErrorMessage error={error} />
        </Form.Field>
    );
};

FormSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    onSearch: PropTypes.func,
    isClearable: PropTypes.bool,
    isSearchable: PropTypes.bool
};
